// extracted by mini-css-extract-plugin
export default {"newsImage":"newsimage_newsImage__JUGBI"};